import axios from 'axios';
import apisUrls from '../urls';

const getAllPaymentTypesApi = (paramsFilter) => {
  return axios.get(apisUrls?.getPaymentTypes);
};

export default getAllPaymentTypesApi;
